import { useDataChanged } from "../Contexts/DataChangedProvider";
import { useData } from "../Contexts/DataProvider";
import { useRibbon } from "../Contexts/RibbonProvider";
import { useSelectedEntity } from "../Contexts/SelectedEntityProvider";
import { useSave } from "./useSave";

export const useSubmit = () => {
  const { data, setData, originalData } = useData();
  const { setDataChanged } = useDataChanged();
  const { selectedEntity } = useSelectedEntity();
  const { handleSaveChanges } = useSave();
  const { addRibbon } = useRibbon();

  const handleSubmit = async () => {
    if (!data || !data.value || data.value.length === 0) {
      addRibbon("Nothing to submit.", "error");
      return;
    }

    const updatedData = {
      ...data,
      value: data.value.map((row: any) => ({
        ...row,
        new_submitted: true,
      })),
      headCount: Array.isArray(data.headCount)
        ? data.headCount.map((row: any) => ({
            ...row,
            new_submitted: true,
          }))
        : data.headCount,
    };

    setData(updatedData);
    setDataChanged(true);

    await handleSaveChanges(updatedData);
    addRibbon("Submitted!", "info");
  };
  return { handleSubmit };
};
